import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Input, { Textarea } from '../../components/utils/Input';
import MainLayout from '../../layouts/MainLayout';

const TestPage = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const [mlmAdvisor, setMLMAdvisor] = useState('');
    const [mlmAdvisorCheckMsg, setMLMAdvisorCheckMsg] = useState('');
    const referralCode = 'TU243BM5850150'; // Using referralCode directly
    const bookId = '66210d4517580762a8fd47f0'; // Using bookId directly
    const [error, setError] = useState('');

    const fetchMLMChart = useCallback(() => {
        // console.log("fetchMLMChart for API call ", referralCode, " for bookId ", bookId);
        
        const config = {
            url: "/mlmchart/advisorasuser",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userCode: referralCode, bookId: bookId }
        };

        fetchData(config)
            .then(response => {
                if (response && response.status === 200) {
                    // console.log("mlm record found ", response.data);
                    setMLMAdvisor(response.data.mlmAdvisor);
                } else {
                    // console.log("mlm record Not found");
                    setMLMAdvisorCheckMsg(`Referral Code ${referralCode} for the book not found in the referral tree! 😔 Make sure the Referral Code is valid.`);
                }
            })
            .catch(error => {
                // console.log("Error fetching MLM record:", error.message);
                setMLMAdvisorCheckMsg(`Error fetching MLM record: ${error.message}`);
            });
    }, [authState.token, referralCode, bookId, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMLMChart(); // Fetch MLM chart data on component mount or authState change
    }, [authState.isLoggedIn, fetchMLMChart]);

    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Test Page</h3>
                <div>
                    <p>{mlmAdvisorCheckMsg}</p>
                </div>
            </div>
        </MainLayout>
    );
};

export default TestPage;
